import { Stack, Typography } from '@mui/material';
import { useProductsTFunction } from '@retail/products/i18n';
import { GwpPhasesType } from './GWPContent';
import { EmissionTypography } from './EmissionTypography';

interface Props {
  title: string;
  phase: GwpPhasesType;
  value?: number;
}

export const GWPNumberElement = ({ title, phase, value }: Props) => {
  const t = useProductsTFunction();

  return (
    <Stack border="0.5px solid" borderColor="divider" alignItems="center" p={1}>
      <Typography variant="h6" fontWeight={500}>
        {t('products.mgItem.gwp.phase', { gwpPhase: phase })}
      </Typography>

      <EmissionTypography value={value} />
      <Typography variant="body2">{t('products.mgItem.gwp.co2')}</Typography>

      <Typography variant="subtitle1" textAlign="center">
        {title}
      </Typography>
    </Stack>
  );
};
